import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 05E12366-E7AA-46B9-8D6E-3664EBD34BB3
 * name code-not-equal-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-not-equal-variant.svg
 * tags
 * - Developer / Languages 
 */
export const CodeNotEqualVariantIcon = createSvgIcon(<><path d="M11,6.5V9.33L8.33,12L11,14.67V17.5L5.5,12M13,6.43L18.57,12L13,17.57V14.74L15.74,12L13,9.26M5,3C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3H5Z" /></>, 'CodeNotEqualVariantIcon');
export default CodeNotEqualVariantIcon